<p>
  three-demo works!
</p>
<div #rendererContainer></div>
